<template>
  <div style="width: 100%;height: 1000px">
    <el-card style="margin:30px;width: 100%;height: 100%">
      <el-button @click="backBtn" size="small" type="primary">返回上一页</el-button>
      <el-button size="small" @click="addBtn" type="success">新增类型</el-button>
      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="listData"
          border
          style="width: 50%;margin-top: 30px"
      >
        <el-table-column label="专题名称" align="center">
          <template>
            <div>{{specialName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="类型名称" prop="specialType" align="center">
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="400"
        >
          <template slot-scope="scope">
            <el-button v-if="type === 1" size="small" type="primary" @click="editNewsBtn(scope.row)">新闻编辑</el-button>
            <el-button v-if="type === 1" size="small" type="primary" @click="previewNewsBtn(scope.row)">查看已有新闻</el-button>
            <el-button v-if="type === 2" size="small" type="primary" @click="editVideoBtn(scope.row)">视频编辑</el-button>
            <el-button v-if="type === 2" size="small" type="primary" @click="previewNewsBtn(scope.row)">查看已有视频</el-button>
            <el-button size="small" @click="editBtn(scope.row)" type="success">修改</el-button>
            <el-button size="small" @click="deleteBtn(scope.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="600px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="类型" prop="title">
          <el-input v-model="ruleForm.title" type="textarea" :rows="3" style="width: 400px" size="small"
                    placeholder="请输入类型名称，多个请用英文分号分割"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>

    <a-modal
        :visible="allNewsDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="type === 1? '新闻编辑':'视频编辑'"
        width="800px"
        @cancel="newsCancel"
        @ok="newsSubmit"
    >
      <div style="display: flex;align-items: center;margin-bottom: 10px">
        <el-input v-if="type === 1" v-model="newsTitle" placeholder="请输入标题" size="small" style="width:200px" clearable></el-input>
        <el-input v-if="type === 2" v-model="title" placeholder="请输入视频名称" size="small" style="width:200px" clearable></el-input>
        <el-button size="small" style="margin-left: 10px" type="primary" @click="searchList">查询</el-button>
        <el-button size="small" style="margin-left: 10px" type="danger" @click="resetAllNewsList">重置</el-button>
      </div>
      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="newsData"
          border
          :row-key="rowKey"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          @select="handleSelectChange"
          @select-all="handleSelectAllChange"
          v-loading="loading"
          class="order"
      >
        <el-table-column
            align="center"
            :reserve-selection="true"
            header-align="center"
            type="selection"
            width="60">
        </el-table-column>
        <el-table-column label="新闻名称" align="center" :prop="type === 1 ? 'news_title':'title'">
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="newsTotal">
      </el-pagination>
    </a-modal>

    <a-modal
        :visible="previewDialogState"
        ok-text="关闭"
        :title="type === 1 ? '已拥有的新闻':'已拥有的视频'"
        width="800px"
        :closable='false'
        :cancel-button-props="{ style: { display: 'none' } }"
        @ok="previewDialogState = false"
    >
      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="previewData"
          border
          :row-key="rowKey"
          style="width: 100%;"
      >
        <el-table-column :label="type === 1 ?'新闻名称':'视频名称'" align="center" :prop="type === 1 ? 'news_title':'title'">
        </el-table-column>
        <el-table-column label="操作" width="100px" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deletePreviewBtn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handlePreviewSizeChange"
          @current-change="handlePreviewCurrentChange"
          :current-page="previewNum"
          :page-size="previewSize"
          layout="total, prev, pager, next, jumper"
          :total="previewTotal">
      </el-pagination>
    </a-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      specialName: null,
      listData: [],
      addDialogState: false,
      dialogTitle: '',
      ruleForm: {
        id: null,
        title: '',
      },
      rules: {
        title: [{required: true, message: "请输入类型名称", trigger: "blur"}],
      },
      deleteDialogState: false,
      deleteId: '',
      simpleDelete: false,//是单个删除还是多个删除
      allNewsDialogState: false,
      typeId: null,
      pageNum:1,
      pageSize: 10,
      newsData:[],
      newsTotal:0,
      multipleSelection: [],
      loading:false,
      selectData:[],
      newsTitle: '',
      title: "",

      previewDialogState:false,
      previewNum:1,
      previewSize:10,
      previewData:[],
      previewTotal:0,
      previewTypeId:null,
      type: null
    }
  },
  created() {
    this.id = this.$route.query.id
    this.specialName = this.$route.query.specialName
    this.type = this.$route.query.type
    this.getList()
    if (this.type === 1){
      this.getAllNewsList()
    } else {
      this.getAllVideoList()
    }
  },
  methods: {
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection,9999)
    },
    handleSelectChange(selection, row){
      let selected = selection.length && selection.indexOf(row) !== -1
      if (selected){
        this.postAxios("/special/type/addNewsBatch", {
          specialTypeId: this.typeId,
          specialNews: [
            {
              newsInfoId: row.id
            }
          ],
        })
      }else{
        console.log('取消选中',row.id)
        this.postAxios("/special/type/delNewsBatch", {
          specialTypeId: this.typeId,
          newsIds: [
            row.id
          ],
        })
      }
    },
    handleSelectAllChange(selection){
      console.log(selection)
    },
    addBtn() {
      this.ruleForm = {
        id:null,
        title:''
      }
      this.dialogTitle = '类型新增'
      this.addDialogState = true
    },
    editBtn(row){
      this.ruleForm.id = row.id
      this.ruleForm.title = row.specialType
      this.dialogTitle = '类型修改'
      this.addDialogState = true
    },
    previewNewsBtn(row){
      this.previewTypeId = row.id
      this.getAxios("/special/getTypeNews", {
        typeId: row.id,
        pageNum:this.previewNum,
        pageSize:this.previewSize
      }).then(res=>{
        if (res&&res.success){
          this.previewData = res.content
          this.previewTotal = res.totalCount
          this.previewDialogState = true
        }
      })
    },
    deletePreviewBtn(row){
      this.postAxios("/special/type/delNewsBatch", {
        specialTypeId: this.previewTypeId,
        newsIds: [
          row.news_info_id
        ],
      }).then(res=>{
        this.$message.success('删除成功!')
        this.getPreviewList()
      })
    },
    editNewsBtn(row){
      this.typeId = row.id
      this.loading = true
      this.getAxios("/special/getTypeNews", {
        typeId: row.id
      }).then(res => {
        if (res.success){
          this.allNewsDialogState = true
          this.$refs.multipleTable.clearSelection();
          setTimeout(()=>{
            if (res.content && res.content.length){
              this.selectData = res.content
              res.content.forEach((itemI)=>{
                this.newsData.forEach((itemII)=>{
                  if (itemI.news_info_id == itemII.id){
                    this.$refs.multipleTable.toggleRowSelection(itemII,true)
                  }
                })
              })
            }else{
              this.$refs.multipleTable.clearSelection();
            }
            this.loading = false
          },1600)
        }
      })
    },
    editVideoBtn(row){
      console.log(this.type)
      this.typeId = row.id
      this.loading = true
      this.getAxios("/special/getTypeNews", {
        typeId: row.id
      }).then(res => {
        if (res.success){
          this.allNewsDialogState = true
          this.$refs.multipleTable.clearSelection();
          setTimeout(()=>{
            if (res.content && res.content.length){
              this.selectData = res.content
              res.content.forEach((itemI)=>{
                this.newsData.forEach((itemII)=>{
                  if (itemI.news_info_id == itemII.id){
                    this.$refs.multipleTable.toggleRowSelection(itemII,true)
                  }
                })
              })
            }else{
              this.$refs.multipleTable.clearSelection();
            }
            this.loading = false
          },1600)
        }
      })
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    backBtn() {
      this.$router.back()
    },
    newsCancel(){
      this.allNewsDialogState = false
    },
    newsSubmit(){
      this.multipleSelection = []
      this.$refs.multipleTable.clearSelection();
      setTimeout(()=>{
        this.allNewsDialogState = false
        this.dialogListReset()
      },500)
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '类型新增') {
            let typeNameList = this.ruleForm.title.split(';')
            this.postAxios("/special/addTypeBatch", {
              specialId: this.id,
              specialType: typeNameList
            }).then(res => {
              this.$message.success("添加成功!")
              this.addDialogState = false
              this.getList()
            })
          } else {
            this.getAxios("/special/type/updateTypeName", {
              specialTypeId: this.ruleForm.id,
              name: this.ruleForm.title
            }).then(res => {
              this.$message.success("修改成功!")
              this.addDialogState = false
              this.getList()
            })
          }
        }
      });
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.getAxios("/special/delete/type", {
          typeId: this.deleteId
        }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }
    },
    getList() {
      this.getAxios("/special/listType", {
        specialId: this.id
      }).then(res => {
        if (res.success) {
          this.listData = res.content
        } else {
          this.listData = []
        }
      })
    },
    searchList(){
      if (this.type === 1){
        this.getAllNewsList();
      }else{
        this.getAllVideoList();
      }
    },
    resetAllNewsList(){
      this.newsTitle = ''
      this.title = ''
      if (this.type === 1){
        this.getAllNewsList();
      }else{
        this.getAllVideoList();
      }
    },
    getAllNewsList(){
      this.loading = true
      this.postAxios("/newNews/getTypeNewsByTypeId", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          newsTitle: this.newsTitle
        }
      }).then(res => {
        if (res.success){
          this.newsData = res.content
          this.newsTotal = res.totalCount
          setTimeout(()=>{
            if (this.selectData && this.selectData.length){
              this.selectData.forEach((itemI)=>{
                this.newsData.forEach((itemII)=>{
                  if (itemI.news_info_id == itemII.id){
                    this.$refs.multipleTable.toggleRowSelection(itemII,true)
                  }
                })
              })
            }else{
              this.$refs.multipleTable.clearSelection();
            }
            this.loading = false
          },1600)
        }
      })
    },
    getAllVideoList(){
      this.postAxios("/special/getAllVideo", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          title: this.title
        }
      }).then(res => {
        if (res.success){
          this.newsData = res.content
          this.newsTotal = res.totalCount
          setTimeout(()=>{
            if (this.selectData && this.selectData.length){
              this.selectData.forEach((itemI)=>{
                this.newsData.forEach((itemII)=>{
                  if (itemI.news_info_id == itemII.id){
                    this.$refs.multipleTable.toggleRowSelection(itemII,true)
                  }
                })
              })
            }else{
              this.$refs.multipleTable.clearSelection();
            }
            this.loading = false
          },1600)
        }
      })
    },
    dialogListReset(){
      this.pageNum = 1
      this.getAllNewsList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      if (this.type === 1){
        this.getAllNewsList()
      }else{
        this.getAllVideoList()
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val
      if (this.type === 1){
        this.getAllNewsList()
      }else{
        this.getAllVideoList()
      }
    },
    handlePreviewSizeChange(val) {
      this.previewSize = val
      this.getPreviewList()
    },
    handlePreviewCurrentChange(val) {
      this.previewNum = val
      this.getPreviewList()
    },
    getPreviewList(){
      this.getAxios("/special/getTypeNews", {
        typeId: this.previewTypeId,
        pageNum:this.previewNum,
        pageSize:this.previewSize
      }).then(res=>{
        if (res&&res.success){
          this.previewData = res.content
          this.previewTotal = res.totalCount
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/.order .el-table__header-wrapper  .el-checkbox{
  display:none
}
</style>

